<div class="border rounded-lg p-4 flex-1 flex flex-col min-h-[50vh] bg-white shadow-sm">
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1.5fr_auto] gap-x-4 gap-y-4 flex-1">

    <!-- Grupo: Información del Comprobante -->
    <div class="space-y-3 p-3 rounded-lg bg-gray-50">
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Comprobante</label>
        <div class="relative">
          <select [(ngModel)]="formulario.datosBasicos.tipo" name="tipo" #tipoInput
            class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 appearance-none outline-none"
            (ngModelChange)="onCompChange($event)">
            @for (comp of comps; track comp.COD_COMP) {
            <option [value]="comp.COD_COMP">{{ comp.DESCRIP }}</option>
            }
          </select>
          <mat-icon class="absolute right-2 top-1.5 text-gray-400 text-base">expand_more</mat-icon>
        </div>
      </div>

      <div class="flex gap-3">
        <div class="flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-1">Sucursal</label>
          <input type="number" [(ngModel)]="formulario.datosBasicos.sucursal" name="sucursal" #sucursalInput
            class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
        </div>

        <div class="flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-1">Número de Comprobante</label>

          <div
            class="flex items-center rounded-md focus-within:ring-2 focus-within:ring-orange-500 focus-within:ring-offset-2 transition-all duration-200">
            <input type="number" [(ngModel)]="formulario.datosBasicos.numero" name="number" #numeroInput
              class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:outline-none">

            <button type="button" (click)="proponerNumeracion()"
              class="h-8 flex-shrink-0 inline-flex items-center justify-center px-1 border border-gray-300 bg-gray-100 rounded-r-md hover:bg-gray-200">
              <span class="sr-only">Proponer numeración de comprobante</span>
              <svg class="h-5 w-5 text-orange-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                  d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                  clip-rule="evenodd" />
              </svg>
            </button>
          </div>


        </div>

      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Remito</label>
        <input type="text" [(ngModel)]="formulario.datosBasicos.remito" name="remito" #remitoInput
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
      </div>
    </div>

    <!-- Grupo: Información del Proveedor -->
    <div class="space-y-3 p-3 rounded-lg bg-gray-50">
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Proveedor</label>
        <input type="text" name="providerName" readonly [value]="formulario.datosBasicos.nombreProveedor"
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm bg-gray-100 outline-none">
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Provincia</label>
        <div class="relative">
          <select [(ngModel)]="formulario.datosBasicos.provincia" name="province" #provinciaSelect
            class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 appearance-none outline-none">
            <option value="">Seleccionar provincia</option>
            @for (provincia of provincias; track provincia.CODI) {
            <option [value]="provincia.CODI">{{ provincia.NOMBRE }}</option>
            }
          </select>
          <mat-icon class="absolute right-2 top-1.5 text-gray-400 text-base">expand_more</mat-icon>
        </div>
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Código de Operación</label>
        <input type="text" name="operationCode" [(ngModel)]="formulario.datosBasicos.codigoOperacion"
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
      </div>
    </div>

    <!-- Grupo: Fechas -->
    <div class="space-y-3 p-3 rounded-lg bg-gray-50">
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">
          <span class="flex items-center gap-1">
            <mat-icon class="text-gray-400 text-sm">event</mat-icon>
            Fecha Emisión
          </span>
        </label>
        <input type="date" [(ngModel)]="formulario.fechas.fechaEmision" name="emissionDate" #fechaEmisionInput
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">
          <span class="flex items-center gap-1">
            <mat-icon class="text-gray-400 text-sm">event</mat-icon>
            Fecha Vencimiento
          </span>
        </label>
        <input type="date" [(ngModel)]="formulario.fechas.fechaVencimiento" name="dueDate" #fechaVencimientoInput
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">
          <span class="flex items-center gap-1">
            <mat-icon class="text-gray-400 text-sm">event</mat-icon>
            Fecha Pago
          </span>
        </label>
        <input type="date" [(ngModel)]="formulario.fechas.fechaPago" name="paymentDate" #fechaPagoInput
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
      </div>
    </div>

    <!-- Grupo: Información de Pago -->
    <div class="space-y-3 p-3 rounded-lg bg-gray-50">
      <div class="flex gap-3">
        <div class="flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-1">Moneda</label>
          <div class="relative">
            <select [(ngModel)]="formulario.datosBasicos.moneda" (ngModelChange)="onCurrencyChange($event)"
              name="currency"
              class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 appearance-none outline-none">
              @for (moneda of monedas; track moneda.mone) {
              <option [value]="moneda.mone">{{ moneda.mone}}</option>
              }
            </select>
            <mat-icon class="absolute right-2 top-1.5 text-gray-400 text-base">expand_more</mat-icon>
          </div>
        </div>
        <div class="flex-1">
          <label class="block text-xs font-medium text-gray-700 mb-1">Cotización</label>
          <input type="number" [(ngModel)]="formulario.datosBasicos.cotizacion" name="exchangeRate"
            [readonly]="formulario.datosBasicos.moneda === 'PES'"
            [class.bg-gray-100]="formulario.datosBasicos.moneda === 'PES'"
            class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
        </div>
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Condición de Pago</label>
        <div class="relative">
          <select [(ngModel)]="formulario.datosBasicos.condicionPago" name="paymentCondition"
            class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 appearance-none outline-none">
            <option value="">Seleccionar condición</option>
            @for (condi of condiVentas; track condi.CONDI_CODI) {
            <option [value]="condi.CONDI_CODI">{{ condi.CONDI_DESCRIP }}</option>
            }
          </select>
          <mat-icon class="absolute right-2 top-1.5 text-gray-400 text-base">expand_more</mat-icon>
        </div>
      </div>
    </div>

    <!-- Grupo: Fechas Adicionales -->
    <div class="space-y-3 p-3 rounded-lg bg-gray-50">
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">
          <span class="flex items-center gap-1">
            <mat-icon class="text-gray-400 text-sm">event</mat-icon>
            Fecha Registro
          </span>
        </label>
        <input type="date" [(ngModel)]="formulario.fechas.fechaRegistro" name="registrationDate" #fechaRegistroInput
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
      </div>

      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">
          <span class="flex items-center gap-1">
            <mat-icon class="text-gray-400 text-sm">event</mat-icon>
            Fecha Presentación
          </span>
        </label>
        <input type="date" [(ngModel)]="formulario.fechas.fechaPresentacion" name="presentationDate"
          #fechaPresentacionInput
          class="h-8 w-full border-gray-300 rounded-md px-2 text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 outline-none">
      </div>
    </div>

    <!-- Grupo: Archivo -->
    <div class="space-y-3 p-3 rounded-lg bg-gray-50">
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-2">Archivo de Factura</label>
        <div class="flex items-center gap-2">
          <label for="invoice-file"
            class="cursor-pointer flex items-center gap-2 border border-gray-300 rounded-md py-1.5 px-3 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
            <mat-icon class="text-gray-500 text-base">upload_file</mat-icon>
            <span class="truncate max-w-[180px]">{{ formulario.archivo.nombre || 'Adjuntar PDF de factura' }}</span>
          </label>
          <button *ngIf="formulario.archivo.binario" (click)="eliminarArchivo()" type="button"
            class="text-red-500 hover:text-red-700 text-sm p-1.5 rounded-full hover:bg-red-50 transition-colors duration-200">
            <mat-icon class="text-sm">delete</mat-icon>
          </button>
        </div>
        <input id="invoice-file" type="file" class="hidden" (change)="onFileSelected($event)" accept=".pdf">
      </div>
    </div>

  </div>
</div>